<template>
  <div class="layer">
    <div class="list" v-if="true">
      <transition-group name="notice">
      <template v-for="item, i in notices">
        <div class="notice" v-if="item.shown" :key="i">
          <div class="close" @click="onClose(item)">
            <i class="iconfont iconguanbianniu2"></i>
          </div>
          <div class="title">
            内测邀请
          </div>
          <div class="content">
            <template v-if="item.type === 'duration'">
              <div class="row">想要一页上限超过20s？</div>
              <div class="row">内测版编辑器已支持场景页时长无上限，时间轴刻度细化至0.1，快来试试吧。</div>
            </template>
            <template v-else>
              对话框、圆形、矩形、三角形、线条，内测版已支持自由绘制基础形状，随心调整样式，快来试试吧。
            </template>
          </div>
          <div class="footer">
            <div class="button" @click="confirm(item)">去体验</div>
          </div>
        </div>
      </template>
    </transition-group>
    </div>
  </div>
</template>
<script>
import {myLocalStorage} from '../../plugins/localStorage';
const keywords = ['对话框','圆形','矩形','三角形','线条'];
const delay = 20000;
export default {
  name: 'invitationNotice',
  data () {
    return {
      shown: false,
      notices: [
        {
          type: 'search',
          shown: false,
          timer: null
        }, {
          type: 'duration',
          shown: false,
          timer: null
        }
      ]
    }
  },
  watch: {
    notices: {
      handler (val, oldVal) {
        const allHidden = val.every(v => !v.shown)
        if (allHidden) {
          this.shown = false;
        }
      },
      deep: true
    },

  },
  created () {
    this.$bus.on('resourcesArea.enterSearch', this.onEnterSearch);
    this.$bus.on('clickTimelinePlusExceeded', this.onDuration);
  },
  beforeDestroy () {
    this.$bus.off('resourcesArea.enterSearch', this.onEnterSearch);
    this.$bus.off('clickTimelinePlusExceeded', this.onDuration);
  },
  methods: {
    onEnterSearch (inputValue) {
      const isKeyword = keywords.includes(inputValue);
      if (!isKeyword) {
        return;
      }
      const {isSearch, isDuration} = myLocalStorage.get('testingInvitationNotice') || {};
      if (!isSearch) {
        this.openNoticeByType('search');
        myLocalStorage.set('testingInvitationNotice', {isSearch: true, isDuration});
      }
    },
    onDuration () {
      const {isSearch, isDuration} = myLocalStorage.get('testingInvitationNotice') || {};
      if (!isDuration) {
        this.openNoticeByType('duration');
        myLocalStorage.set('testingInvitationNotice', {isSearch, isDuration: true});
      }
    },
    openNoticeByType (type) {
      this.toggleNotice(true, {type, shown: true});
      const noticeData = this.notices.find(v => v.type === type);
      const timer = setTimeout(() => {
        this.$set(noticeData, 'shown', false);
      }, delay);
      this.$set(noticeData, 'timer', timer);
    },
    toggleNotice (flag, {type, shown}) {
      this.shown = flag;
      this.notices.some(v => {
        if (v.type === type) {
          this.$set(v, 'shown', shown);
          clearTimeout(v.timer);
          this.$set(v, 'timer', null);
          return true;
        }
      })
    },
    onClose (item) {
      this.toggleNotice(true, {type: item.type, shown: false});
    },
    closeAll () {
      this.notices.map(v => {
        this.toggleNotice(false, {type: v.type, shown: false});
      });
    },
    confirm (item) {
      this.closeAll();
      const m = {
        search: '形状功能进入新版',
        duration: '时长功能进入新版'
      }
      this.$store.commit('save_TopnavMsg', {
        isVersionSwitchNew: true,
        versionSwitchNewType: m[item.type],
      });
      // sensors.track('laipicBetaVersionSwap', {
      //   swap_type: m[item.type]
      // });
    }
  }
}
</script>
<style lang="scss" scoped>
.layer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 30;
}
.list {
  position: fixed;
  top: 64px;
  right: 4px;
}
.notice {
  position: relative;
  width: 330px;
  height: 212px;
  background: linear-gradient(179deg, #FFEBFC 0%, #EFF4FF 65%, #FFFFFF 100%);
  background-image: url(../../assets/invitation/notice-bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  box-shadow: 0px 2px 12px rgba(0,0,0,0.16);
  opacity: 1;
  border-radius: 4px;
  margin-bottom: 24px;
  .close {
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
  }
  .title {
    padding: 25px 32px 12px;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
  }
  .content {
    text-align: left;
    line-height: 22px;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 23px;
  }
  .footer {
    display: flex;
    justify-content: center;
    align-content: center;
  }
}
.button {
  display: flex;
  align-content: center;
  justify-content: center;
  width: 126px;
  height: 38px;
  background: #5778FB;
  opacity: 1;
  border-radius: 4px;
  color: #fff;
  &:hover {
    background-color: #7d95f5;
    cursor: pointer;
  }
}
.notice-enter-active,
.notice-leave-active {
  transition: all .3s ease;
}

.notice-enter,
.notice-leave-to {
    transform: translateX(50%);
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/invitationNotice/index.vue